import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import moment from 'moment';
import * as auth from 'core/auth';
import * as api from 'core/api';
import { UserState } from 'core/store/modules/user';
import { FETCH_USER_COUPONS } from 'core/store/action-types';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class AccountCouponsComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    get viewState(): string {
        if (this.loadingInProggress) {
            return 'loading';
        }
        if (this.userCoupons && this.userCoupons.length > 0) {
            return 'result';
        }
        if (this.userCoupons && this.userCoupons.length == 0) {
            return 'empty';
        }
        if (this.gotErrorAfterLoading) {
            return 'error';
        }
        return '';
    }

    get userCoupons(): api.CouponListModel[] | undefined {
        return (<UserState>this.$store.state.user).coupons;
    }

    loadingInProggress: boolean = false;
    gotErrorAfterLoading: boolean = false;

    mounted() {
        window.document.title = i18next.t('title_coupons');
        this.loadModel();
    }

    loadModel() {
        if (this.userCoupons == null) {
            this.loadingInProggress = true;
            this.gotErrorAfterLoading = false;
            this.$store.dispatch(FETCH_USER_COUPONS)
                .then(() => {
                    this.loadingInProggress = false;
                })
                .catch(() => {
                    this.loadingInProggress = false;
                    this.gotErrorAfterLoading = true;
                });
        }
    }

    // TODO: Это вынести бы в геттеры в store
    getExpiresLabel(coupon: api.CouponListModel): string {
        return i18next.t('label_coupon_expires',
            <any>{ i: moment(coupon.expiryDate).format(i18next.t('format_date_md')) }
        );
    }

    // TODO: Это вынести бы в геттеры в store
    getCouponUseUrl(coupon: api.CouponListModel): string {
        return '/go/coupon/' + coupon.name;
    }

    gotoCouponUrl(coupon: api.CouponListModel): void {
        const origin = location.origin.replace('-m.', '.');
        const pathname = this.getCouponUseUrl(coupon);
        location.href = origin + pathname;
    }
}
